




















import Vue from 'vue'
import Component from 'vue-class-component'
import {Prop} from 'vue-property-decorator';
import {Colors, notify} from '@/modules/core/notification';

/**
 * Edición del transportista
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class CarrierDetail extends Vue {
    /**
     * Controla la visibilidad de componente
     */
    @Prop({type: Boolean, default: false})
    public value: boolean

    /**
     * Indica si el componente esta guardando una transportista
     */
    public saving = false

    /**
     * Ejecuta el guardado del transportista actualmente en edición por el usuario
     */
    public async save () {
        this.saving = true
        await this.$store.dispatch('shipping/saveCarrier')

        this.saving = false
        // Cierra el modal de edición
        this.$emit('input', false)
        notify('El transportista se ha guardado correctamente')
    }

    public errorCaptured (error: Error) {
        this.saving = false
        notify(error.message, Colors.Error)
    }
}
